import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on every route change (premium sites never keep stale scroll).
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
